import {useMapsLibrary} from '@vis.gl/react-google-maps';

import {isEmpty} from 'ramda';

import {TestIdProps} from 'shared/web';

import {getRouteDistances} from '../utils/getRouteDistances';
import {smoothRoute} from '../utils/smoothRoute';
import {AnimatedRouteMap} from './AnimatedRouteMap';

type TestDriveRouteMapContentProps = TestIdProps & {
  encodedRoute: string;
};

export function TestDriveRouteMapContent(props: TestDriveRouteMapContentProps) {
  // The decoder is part of the Maps JavaScript API, so the route can be read only once it loads.
  const geometry = useMapsLibrary('geometry');
  const decoded =
    geometry?.encoding.decodePath(props.encodedRoute).map((point) => point.toJSON()) ?? [];

  if (isEmpty(decoded)) {
    return null;
  }

  // Prepared here and not in the animated map, which renders on every animation frame.
  const path = smoothRoute(decoded);

  // A new route starts a new animation, so the animated map is reset by its key.
  return (
    <AnimatedRouteMap
      key={props.encodedRoute}
      path={path}
      distances={getRouteDistances(path)}
      data-testid={props['data-testid']}
    />
  );
}
